$(document).on("turbolinks:load", () => {
    select_examination_for_export()
    $("#inquiry_export_form_examination_for_disp").change(function(){
        select_examination_for_export()
    }); 

    // CSVエクスポート時のsubmitボタンdisabled外す処理
    $(document).on('submit', '.csv_export', function(e){
        const val = $('#csv_button').val();
        setTimeout(function(){
            $('#csv_button').prop('disabled', false).val(val);
        }, 500);
    });
})

function select_examination_for_export(){
    var code = $("#inquiry_export_form_examination_for_disp option:selected").data("examination-code");
    if (code != undefined){
        document.getElementById('new_inquiry_export_form').action= "/" + code.toLowerCase() + "_inquiries/export.csv" ;
    }    
}

